import CauseComponent from "../components/CauseCoponent"
import Header from "../components/Header"
import HistoryComponent from "../components/HistoryComponent"


const AboutPage =() => {

    return (
        <>
            <Header type="about"></Header>

            <HistoryComponent />

            <CauseComponent />

        </>
    )
}


export default AboutPage